import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { createAlert } from '../scripts/createAlert';

export default class extends Controller {
  static targets = [ "questionsContainer", "question", "sortable", "form" ]
  static values = {
    templateId: Number,
  }

  updateQuestionNumbers() {
    const cards = this.questionsContainerTarget.querySelectorAll('.question-sortable')
    Array.from(cards).forEach((card, idx) => {
      const label = card.querySelector('[data-question-number]')
      if (label) label.textContent = idx + 1
    })
  }

  connect() {
    // console.log("Hello, Stories Interview Template Questions Controller here!", this.element)
    // console.log(this.questionsContainerTarget)
    // console.log(this.questionTargets)

    this.sortableTargets.forEach(elm => {
      Sortable.create(elm, {
        draggable: '.question-sortable',
        dataIdAttr: 'data-sortable-id',
        handle: ".sortable-handle",  // Drag handle selector within list items

        // Changed sorting within list
        onUpdate: (event) => {
          const rows = event.target.querySelectorAll('.question-sortable');
          const attachmentIds = Array.from(rows).map(elm => elm.dataset.attachmentId)

          const token = $('meta[name="csrf-token"]').attr('content');
          $.ajaxSetup({
            beforeSend: function (xhr) {
              xhr.setRequestHeader('X-CSRF-Token', token);
            }
          });

          $.post(`/interview_templates/${this.templateIdValue}/reorder`, { ordered_question_ids: attachmentIds }).then(() => {
            createAlert('success', 'Question order updated')
          })

          this.updateQuestionNumbers()
        }
      });
    })

    this.updateQuestionNumbers()
  }

  addQuestion() {
    fetch(`/interview_templates/${this.templateIdValue}/questions/new`).then(res => res.text()).then(partial => {
      // partial comes with no index field, need to dynamically update it
      partial = partial.replace(/NEW_ID/g, this.questionTargets.length + 1)

      this.questionsContainerTarget.insertAdjacentHTML( 'beforeend', partial );

      this.updateQuestionNumbers()
    });
  }

  deleteUnsavedQuestion(event) {
    event.preventDefault();
    const question = event.target.closest('.question-sortable');

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const questionId = question?.dataset?.attachmentId

    // If the question has an ID (e.g. auto-created during recording), delete it from the backend.
    if (questionId) {
      fetch(`/interview_templates/${this.templateIdValue}/questions/${questionId}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        }
      }).then(() => {
        question.remove();
        createAlert('success', 'Question removed')
        this.updateQuestionNumbers()
      }).catch(() => {
        createAlert('danger', 'Unable to remove question')
      })
      return
    }

    question.remove();
    createAlert('success', 'Question removed')
    this.updateQuestionNumbers()
  }

  attemptSubmit(event) {
    // when submitting, need to make sure each question has at least a single response mode selected
    event.preventDefault();

    var valid = true, responseModeErrorMessage, textErrorMessage, errorMessage;
    // debugger;
    this.questionTargets.forEach(question => {

      let questionValid = true;
      let responseModes = Array.from(question.querySelectorAll('.video-response, .audio-response, .text-response'));
      if (responseModes.every(elm => !elm.checked)) {
        question.querySelector('textarea').classList.add('is-invalid');
        responseModeErrorMessage = 'Please select at least one response mode for each question.'
        valid = false;
        questionValid = false;
      }

      if (question.querySelector('.question-text').value === '') {
        question.querySelector('.question-text').classList.add('is-invalid');
        textErrorMessage = 'Please make sure all questions have text before saving.'
        valid = false;
        questionValid = false;
      }

      if (questionValid) {
        question.querySelector('.question-text').classList.remove('is-invalid');
      }
    });

    if (valid) {
      this.formTarget.submit();
    } else {
      if (textErrorMessage && responseModeErrorMessage) {
        errorMessage = "Please make sure all fields are filled out before saving."
      } else {
        errorMessage = textErrorMessage || responseModeErrorMessage
      }

      createAlert('danger', errorMessage)
    }
  }

}
